var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meetings-list-container",class:[
    `${_vm.widgetSettings.widget_style_settings.ew_events_list_view}-view-mode`,
  ]},[(_vm.widgetSettings.widget_style_settings.show_filters_expanded)?_c('EventsFiltersMultiSelect'):_vm._e(),_c('div',{staticClass:"svv-workflow-with-calendar"},[(
        _vm.widgetSettings.widget_style_settings.show_calendar &&
        !_vm.widgetSettings.widget_style_settings.ew_show_top_filters &&
        !_vm.isBundlePage &&
        !_vm.widgetSettings.widget_style_settings.show_filters_expanded
      )?_c('EventsCalendarSection',{class:{
        'open-desktop-calendar': true,
        'permanently-open': true,
        'svv-calendar-section': true,
      }}):_vm._e(),_c('EventsList')],1),(_vm.isLoading)?_c('div',{staticClass:"list-loader"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svv-loader center"},[_c('span')])
}]

export { render, staticRenderFns }